import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=7e8c0673&"
import script from "./teams.vue?vue&type=script&lang=ts&"
export * from "./teams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports